//var $ =
//require('jquery');

import './show-more';

import cookieMgrCtor from './cookie-manager';
const cookieMgr = new cookieMgrCtor();

import blockHelperCtor from './blocks';
const blockHelper = new blockHelperCtor(cookieMgr);

$(function () {
    blockHelper.showActive();


    $('.btnNew').on('click', function (e) {
        e.stopPropagation();
    });

    $('#sidebar, main').fadeIn(333);
});